// extracted by mini-css-extract-plugin
module.exports = {"videoModalComponent":"ModalComponentGenerator_videoModalComponent__3KkaI"};